module.exports = __webpack_public_path__ + "img/bookmark-mobile.1e4a4f64.svg";